import './quote-transport.scss';

import { Outlet } from "react-router-dom";

import { FilterQuoteTransportProvider } from "./filter-quote-transport/filter-quote-transport.context";

export function QuoteTransport() {
  return (
    <div id="ShellQuoteTransport" className="quote-transport">
       <FilterQuoteTransportProvider>
        <Outlet />
      </FilterQuoteTransportProvider>
    </div>
  );
}

export default QuoteTransport;
